export default "__VITE_ASSET__DcS46q9d__"